document.addEventListener('DOMContentLoaded', () => {

    const collectionPage = document.querySelector('.page-template-template-collections')

    if (collectionPage !== null) {

        document.querySelectorAll('.c-collection-item__colors-bar__item').forEach(function (color) {
            color.addEventListener('click', function () {

                const parentSelector = '#collection-' + this.dataset.collectionId
                const selectedImageUrl = this.dataset.url
                const selectedImageSrcSet = this.dataset.srcset

                const parentImage = document.querySelector(parentSelector + ' .c-collection-item__image img')
                const currentColor = document.querySelector(parentSelector + ' .is-active')
                parentImage.src = selectedImageUrl

                if(selectedImageSrcSet){
                    parentImage.srcset = selectedImageSrcSet
                }

                currentColor.classList.remove('is-active')
                this.classList.add('is-active')
            })
        })

        document.querySelectorAll('.c-collection-brands__item').forEach(function (brand) {
            brand.addEventListener('click', function () {

                const form = document.querySelector('.js-brand-filter')
                const existingInput = document.querySelector('#brand-' + this.dataset.id)

                const activeBrandFilter = document.querySelector('.c-collection-brands__item.active')
                const activeBrandId = activeBrandFilter?.dataset.id
                const activeBrandInput = document.querySelector('#brand-' + activeBrandId)

                activeBrandInput?.parentNode.removeChild(activeBrandInput)

                if (!this.classList.contains('active')) {
                    if (typeof existingInput == 'undefined' && !existingInput.length || existingInput === null) {
                        form.innerHTML = form.innerHTML + '<input type="hidden" name="filter_brand" id="brand-' + this.dataset.id + '" value="' + this.dataset.slug + '" />';
                    }
                }

                form.submit()

            })
        })

    }

})